export const VariableOptions = [
  { value: "first name}}", label: "First Name" },
  { value: "last name}}", label: "Last Name" },
  { value: "company}}", label: "Company" },
  { value: "other}}", label: "Other" },
] as const

export const hasCustomTemplateVariables = (template: { bodyHtml: string; subject?: string | null }) => {
  const defaultVariables = VariableOptions.map((o) => o.value.replace("}}", ""))
  const regex = new RegExp(`data-beautiful-mention="{{(?!${defaultVariables.join("|")}})[^}]+}}`)

  return !!(template.subject?.match(regex) || template.bodyHtml.match(regex))
}
